import React from 'react';
import GenerateCss from '../functions/GenerateCss.jsx';
import useSyncCompiledCss from '../hooks/useSyncCompiledCss.jsx';

function Style( { attributes, blockId, setAttributes } ) {
	const unique = blockId
		? `.alpha-icon-block-${ blockId }`
		: '.wp-block-alphablock-icon';
	const {
		iconSize,
		minHeight,
		contentVerticalAlignment,
		maxContentWidth,
		contentHorizontalAlignment,
		padding,
		margin,
		iconBorder,
		iconColor,
		iconOpacity,
		iconRotation,
		shapeColor,
		shapeBorderRadius,
		shapePadding,
		shapeOutlineWidth,
		shapeOutlineColor,
		backgroundColor,
	} = attributes;

	const CssObj = {
		[ unique ]: [
			GenerateCss.padding( padding ),
			GenerateCss.margin( margin ),
			GenerateCss.lengthProp( 'min-height', minHeight ),
			GenerateCss.backgroundColor( backgroundColor ),
			GenerateCss.lengthProp( 'max-width', maxContentWidth ),
			GenerateCss.css( 'display', 'flex' ),
			GenerateCss.css( 'justify-content', contentHorizontalAlignment ),
			GenerateCss.css( 'align-items', contentVerticalAlignment ),
			GenerateCss.css( 'width', '100%' ),
		],
		[ `${ unique } .alpha-icon` ]: [
			GenerateCss.lengthProp( 'width', iconSize ),
			GenerateCss.lengthProp( 'height', iconSize ),
			GenerateCss.css( 'display', 'inline-flex' ),
			GenerateCss.css( 'align-items', 'center' ),
			GenerateCss.css( 'justify-content', 'center' ),
			GenerateCss.border( iconBorder ),
			GenerateCss.lengthProp( 'opacity', iconOpacity ),
			GenerateCss.css(
				'transform',
				`rotate(${ iconRotation?.desktop?.val || 0 }deg)`
			),
			GenerateCss.backgroundColor( shapeColor ),
			GenerateCss.borderRadius( shapeBorderRadius ),
			GenerateCss.padding( shapePadding ),
			GenerateCss.lengthProp( 'outline-width', shapeOutlineWidth ),
			GenerateCss.css( 'outline-color', shapeOutlineColor?.color ),
			GenerateCss.css(
				'outline-style',
				shapeOutlineColor?.color && shapeOutlineWidth?.desktop?.val > 0
					? 'solid'
					: 'none'
			),
		],
		[ `${ unique } .alpha-icon svg` ]: [
			GenerateCss.css( 'width', '100%' ),
			GenerateCss.css( 'height', '100%' ),
			GenerateCss.fillColor( iconColor ),
		],
	};

	const compiledCss = GenerateCss.CompiledCss( CssObj );

	useSyncCompiledCss( compiledCss, setAttributes );

	return <style>{ compiledCss }</style>;
}

export default Style;
